import { Link } from "react-router-dom";
import { EvidenceChip, SourcesGroup } from "../EvidenceChip";

export const QUESTIONS = [
  ["what", "What is Philosophy?"], ["who", "Will I like it?"], ["study", "What will I study?"], ["offered", "Where is it offered?"],
  ["rankings", "Who's best at it?"], ["careers", "Where does it lead?"], ["roi", "Is it worth it?"], ["where", "Where should I study?"],
];

export function QSection({ id, n, title, lede, children }) {
  return (
    <section id={id} data-testid={`sci-q-${id}`} className="scroll-mt-28 border-t border-stone-200 py-14 lg:py-20">
      <div className="mb-8 flex items-baseline gap-4">
        <span className="font-mono text-sm text-[#92400E]">{String(n).padStart(2, "0")}</span>
        <div>
          <h2 className="font-editorial text-3xl text-stone-900 lg:text-4xl">{title}</h2>
          {lede && <p className="mt-2 max-w-2xl text-sm text-stone-600 md:text-base">{lede}</p>}
        </div>
      </div>
      {children}
    </section>
  );
}

export const capFirst = (t = "") => t.charAt(0).toUpperCase() + t.slice(1);

export const Unavailable = ({ children, testId }) => (
  <p data-testid={testId} className="rounded-lg border border-dashed border-stone-300 px-4 py-3 text-sm italic text-stone-500">{children}</p>
);

export const Method = ({ children, testId }) => (
  <p data-testid={testId} className="mt-4 max-w-3xl text-[11px] leading-relaxed text-stone-500"><span className="font-mono uppercase tracking-wider">Method · </span>{children}</p>
);

export function QuestionNav() {
  return (
    <nav aria-label="Questions on this page" data-testid="sci-question-nav" className="flex flex-wrap gap-2">
      {QUESTIONS.map(([id, label], i) => (
        <a key={id} href={`#${id}`} data-testid={`sci-question-nav-${id}`}
          className="rounded-full border border-stone-300 bg-white px-3 py-1.5 text-xs text-stone-700 transition-colors hover:border-[#002147] hover:text-[#002147]">
          <span className="mr-1 font-mono text-[10px] text-[#92400E]">{i + 1}</span>{label}
        </a>
      ))}
    </nav>
  );
}

export const CourseLink = ({ id, children, testId }) => (
  <Link to={`/preview/sci/courses/${id}`} data-testid={testId} className="text-[#002147] underline-offset-2 hover:underline">{children}</Link>
);

// Authored sentence + discreet source buttons; the popover keeps the exact official wording.
export const Prose = ({ item, testId, className = "text-[15px] leading-relaxed text-stone-800", as: Tag = "p" }) => (
  <Tag data-testid={testId} className={className}>
    {item.text}
    {item.claims.length >= 3
      ? <SourcesGroup claims={item.claims} testId={`${testId}-sources`} />
      : item.claims.map((c, i) => <EvidenceChip key={i} claim={c} subtle testId={`${testId}-source${i ? `-${i}` : ""}`} />)}
  </Tag>
);
